(function () {
  'use strict';

  class PandisweltShippingInfo extends HTMLElement {
    constructor() {
      super();
      this._oeffnen = this._oeffnen.bind(this);
      this._schliessen = this._schliessen.bind(this);
      this._klickAufHintergrund = this._klickAufHintergrund.bind(this);
    }

    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('[data-shipping-open]');
      this.closer = this.querySelector('[data-shipping-close]');

      if (!this.dialog || !this.trigger) return;

      /* Aeltere Browser ohne showModal: Trigger ausblenden,
         damit niemand ins Leere klickt. */
      if (typeof this.dialog.showModal !== 'function') {
        this.trigger.hidden = true;
        return;
      }

      this.trigger.addEventListener('click', this._oeffnen);
      if (this.closer) this.closer.addEventListener('click', this._schliessen);
      this.dialog.addEventListener('click', this._klickAufHintergrund);
    }

    disconnectedCallback() {
      if (this.trigger) this.trigger.removeEventListener('click', this._oeffnen);
      if (this.closer) this.closer.removeEventListener('click', this._schliessen);
      if (this.dialog) this.dialog.removeEventListener('click', this._klickAufHintergrund);
    }

    _oeffnen() {
      this.dialog.showModal();
      document.body.classList.add('pandiswelt-ship-open');
    }

    _schliessen() {
      this.dialog.close();
    }

    /* Klick auf die Flaeche ausserhalb des Inhalts schliesst das Popup */
    _klickAufHintergrund(event) {
      if (event.target === this.dialog) {
        this.dialog.close();
      }
    }
  }

  /* Scroll-Sperre wieder aufheben, egal wie geschlossen wurde */
  document.addEventListener('close', function (event) {
    if (event.target && event.target.classList
      && event.target.classList.contains('pandiswelt-ship__dialog')) {
      document.body.classList.remove('pandiswelt-ship-open');
    }
  }, true);

  if (!customElements.get('pandiswelt-shipping-info')) {
    customElements.define('pandiswelt-shipping-info', PandisweltShippingInfo);
  }
})();
